import React, { useEffect, useState, useRef, Fragment } from "react";
import cardHolderService from "../../services/cardholder.service";
import DateFormat from "../../helpers/DateFormat";
import ModelPopup from "../../helpers/ModelPopup";
import BoLoader from "../../helpers/BoLoader";
import RefreshToken from "../../helpers/RefreshToken";
import { useDispatch, useSelector } from "react-redux";
import DialoguePopup from "../../helpers/DialoguePopup";

import SearchGridBankAccountTransactions from "./SearchGridBankAccountTransactions";
import BankService from "../../services/bank.services";
import './bankaccount.css'
import AddInternalTransferBody from "./AddInternalTransferBody";
import AddExtrnalTransferBody from "./AddExternalTransferBody";

const BankAccountHolderDetails = props => {
 
  const [cardHolderDetail, setCardHolderDetail] = useState();
  const [cardHolderDetailSuccessful, setcardHolderDetailSuccessful] =
    useState(false);
 
  const [boloader, setBoLoader] = useState(false);
  const [userId, setUserId] = useState(props?.location?.state?.userId);
 
  const { user: currentUser } = useSelector(state => state.auth);
  
  const form = useRef();
  const checkBtn = useRef();
  
  const [modelhdng, setMdlHdng] = useState("");
  const [modelbdy, setMdlBdy] = useState("");
  const [MdlIcon, setMdlIcon] = useState("");
  const [dialougemodalShow, setDialougemodalShow] = useState(false);
  const [dataset, setDataset] = useState();
  
  //Transactions types
  const [AllTransactionClassName, setAllTransactionClassName] = useState("nav-link active");
  const [AllTransactionAreaSelected, setAllTransactionAreaSelected] = useState("true");
  const [SendMoneyClassName, setSendMoneyClassName] = useState("nav-link");
  const [SendMoneyAreaSelected, setSendMoneyAreaSelected] = useState("false");

  const [kycstatus, setKycstatus] = useState("");
  const [balance, setBalance] = useState("");
  
  const [modalShowInternalAccountTransfer, setModalShowInternalAccountTransfer] = useState(false);
  const [modalShowExternalAccountTransfer, setModalShowExternalAccountTransfer] = useState(false);
 
  useEffect(() => {
    setBoLoader(true);
    setcardHolderDetailSuccessful(false);
    callHolderServiceCall();
    setcardHolderDetailSuccessful(false);
  }, [props?.location?.state]);
  const callHolderServiceCall = async () => {
    await cardHolderService
      .GetAccountDetails(props?.location?.state?.id)
      .then(res => {
        if (res && res.data && res.data.success) {
          if (res && res.data && res.data.payload) {
            setCardHolderDetail(res.data.payload?.item1);
            setcardHolderDetailSuccessful(true);

          } else {
            setcardHolderDetailSuccessful(false);
          }
        }
        setBoLoader(false);
      })
      .catch(err => {
        setBoLoader(false);
        (async () => {
          let resp = await RefreshToken(
            err && err.response && err.response.status
          );
          if (resp) {
            window.location.reload();
            setBoLoader(false);
          } else {
            setBoLoader(false);
          }
        })();
        setcardHolderDetailSuccessful(false);
      });
  };
useEffect(()=>{
BankService.checkstatus(props?.location?.state?.id).then((resp)=>{
  
    let msg = JSON.parse(resp?.data?.message);
    setKycstatus(msg?.process_status);
  
}).catch((error)=>{
  try {
    let msgBody = error?.message;
    setBalance(error?.message ?? "");
  } catch (e) {
    console.error("Error parsing error message:", e);
  }
});
},[])

  useEffect(()=>{
    BankService.checkaccountbalance(props?.location?.state?.id).then((resp)=>{ 
        let msg = JSON.parse(resp?.data?.message);
        setBalance(msg?.process_status);
    }).catch((error)=>{
      try {
        let msgBody = error?.message;
        setBalance("0");
      } catch (e) {
        console.error("Error parsing error message:", e);
      }
    });
    },[])
    useEffect(()=>{
      BankService.getaccounttransactions(props?.location?.state?.id).then((resp)=>{ 
          let msg = JSON.parse(resp?.data?.message);
          setBalance(msg?.process_status);
      }).catch((error)=>{
        try {
          let msgBody = error?.message;
          setBalance("0");
        } catch (e) {
          console.error("Error parsing error message:", e);
        }
      });
      },[])

  const errorAndSuccessModl = (heading, body, errIcon) => {
    setDialougemodalShow(true);
    setMdlHdng(heading);
    setMdlBdy(body);
    setMdlIcon(errIcon);
  };
 
 
  const refereshPage = () => {
    setBoLoader(true);
    callHolderServiceCall();
  }
  
  const transactionTab = () => {
    setAllTransactionClassName("nav-link active d-flex align-items-center");
    setAllTransactionAreaSelected("true");
    setSendMoneyClassName("nav-link d-flex align-items-center");
    setSendMoneyAreaSelected("false");
  }
 
  const InternalAccountPopupHandler=()=>{
    setModalShowInternalAccountTransfer(true);
  }
  const ExtrernalAccountPopupHandler=()=>{
    setModalShowExternalAccountTransfer(true);
  }
  return (
    <div className="col-xl-9 col-lg-12 bo-main-content">
      <BoLoader loading={boloader} />
      {cardHolderDetailSuccessful ? (
        <Fragment>
          <div className="row align-items-center">
            <div className="col-lg-2 mb-24">
              <h3>Bank Account Detail</h3>
            </div>
            <div className="col-lg-10 mb-24">
              <div className="form-group submit-field d-md-flex justify-content-end btns-four">

                
                <button
                  className="btn btn-large btn-extra-large mr-19 mb-3 mb-md-0 res-custom-btn"
                  onClick={InternalAccountPopupHandler}
                >
                   Internal Transfer
                </button>
                <button
                  className="btn btn-large btn-extra-large mr-19 mb-3 mb-md-0 res-custom-btn"
                  onClick={ExtrernalAccountPopupHandler}
                >
                   External Transfer
                </button>
               
              </div>
            </div>

          </div>

          <div className="row-card-holder-details mb-40">
            <div className="row flex-column-reverse flex-sm-row">
              <div className="col-md-12 col-sm-8">
                <ul className="ul-card-details">
                  <li>
                    <div className="mb-20">
                      <p>Client Name</p>
                      <h5>{cardHolderDetail?.clientName}</h5>
                    </div>

                    <div className="mb-20">
                      <p>Email</p>
                      <h5 className="text-break"> {cardHolderDetail?.email}</h5>
                    </div>
                    <div className="mb-20">
                      <p>Currency</p>
                      <h5>
                        $
                      </h5>
                    </div>
                    <div className="mb-20">
                      <p>Date of Birth</p>
                      <h5>
                        <DateFormat date={cardHolderDetail?.dateOfBirth} />
                      </h5>
                    </div>
                  </li>
                  <li>
                    <div className="mb-20">
                      <p>Account Title</p>
                      <h5> {cardHolderDetail?.firstName+ ` `+cardHolderDetail?.lastName}</h5>
                    </div>
                    <div className="mb-20">
                      <p>City</p>
                      <h5> {cardHolderDetail?.city}</h5>
                    </div>
                    <div className="mb-20">
                      <p>Country</p>
                      <h5> {cardHolderDetail?.country}</h5>
                    </div>
                    <div className="mb-20">
                      <p>Zip Code</p>
                      <h5> {cardHolderDetail?.zipCode}</h5>
                    </div>
                    <div className="mb-20">
                      <p>Balance</p>
                      <h5> {balance}</h5>
                    </div>
                  </li>
                  <li>
                  <div className="mb-20">
                      <p>Account Number ACH</p>
                      <h5> {cardHolderDetail?.accountNumberAch ? cardHolderDetail?.accountNumberAch:"-"}</h5>
                    </div>
                    <div className="mb-20">
                      <p>Routing Number ACH</p>
                      <h5> {cardHolderDetail?.routingNumberAch ? cardHolderDetail?.routingNumberAch:"-"}</h5>
                    </div>
                    <div className="mb-20">
                      <p>Account Number FED</p>
                      <h5> {cardHolderDetail?.accountNumberFed ? cardHolderDetail?.accountNumberFed:"-"}</h5>
                    </div>
                    <div className="mb-20">
                      <p>Routing Number FED</p>
                      <h5> {cardHolderDetail?.routingNumberFed?cardHolderDetail?.routingNumberFed:"-"}</h5>
                    </div>
                    <div className="mb-20">
                      <p>Account Number Swift</p>
                      <h5> {cardHolderDetail?.accountNumberSwift?cardHolderDetail?.accountNumberSwift:"-"}</h5>
                    </div>
                    <div className="mb-20">
                      <p>Swift Bic</p>
                      <h5> {cardHolderDetail?.swiftBic ? cardHolderDetail?.swiftBic:"-"}</h5>
                    </div>

                  </li>
                 <li>
                 <div className="mb-20">
                      <p>Token Id</p>
                      <h5> {cardHolderDetail?.tokenId}</h5>
                    </div>
                    <div className="mb-20">
                      <p>KYC Status</p>
                      <h5> {kycstatus}</h5>
                    </div>
                 </li>
                </ul>
              </div>
             
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-sm-12">
              <div className="bo-tabs-mbl">
                <ul className="nav nav-tabs" id="myTab2" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className={AllTransactionClassName}
                      id="allClients-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#allClients"
                      type="button"
                      role="tab"
                      onClick={transactionTab}
                      aria-controls="allClients"
                      aria-selected={AllTransactionAreaSelected}
                    >
                      <span ></span> Tranasactions
                    </button>

                  </li>
                 
                </ul>
              </div>
            </div>

          </div>
          {
            AllTransactionAreaSelected === "true" && (
              <SearchGridBankAccountTransactions
                placeholdervalue="Search Card Holder Transactions"
                headersdata={[
                  "ICON",
                  "TRANSACTION TYPE",
                  "CURRENCY",
                  "AMOUNT",
                  "DATE",
                  "STATUS",
                ]}
                screenname="cardholdertransactions"
                UserId={props?.location?.state?.id}
                issuerCategory={props?.location?.state?.issuerCategory}
                setDataset={setDataset}
                calledfrom="accounttransaction"
              />
            )
          }
          {
            SendMoneyAreaSelected === "true" && (
              <SearchGridBankAccountTransactions
                placeholdervalue="Search Card Holder Transactions"
                headersdata={[
                  "Value",
                "TransactionDate",
                "TransactionStatus",
                "TransactionType",
                "Description"
                ]}
                screenname="cardholdertransactions"
                UserId={props?.location?.state?.id}
                issuerCategory={props?.location?.state?.issuerCategory}
                setDataset={setDataset}
                calledfrom="benificiarylist"
              />
            )
          }


    <ModelPopup
      show={modalShowInternalAccountTransfer}
      onHide={()=>{setModalShowInternalAccountTransfer(false)}}
      modelheading={""}
      showheader={"false"}
      className="smallPopup issueCardSmall"
      dialogClassName="modal-dialog modal-dialog-centered mwidth-76"
      backdrop="static"
      keyboard={false}
      modelbody={<AddInternalTransferBody show={modalShowInternalAccountTransfer} onHide={()=>{setModalShowInternalAccountTransfer(false)}} />}
    />
     <ModelPopup
      show={modalShowExternalAccountTransfer}
      onHide={()=>{setModalShowExternalAccountTransfer(false)}}
      modelheading={""}
      showheader={"false"}
      className="smallPopup issueCardSmall"
      dialogClassName="modal-dialog modal-dialog-centered mwidth-76"
      backdrop="static"
      keyboard={false}
      modelbody={<AddExtrnalTransferBody show={modalShowExternalAccountTransfer} onHide={()=>{setModalShowExternalAccountTransfer(false)}} customerid={cardHolderDetail?.customerId} />}
    />
        
          <DialoguePopup
            show={dialougemodalShow}
            onHide={() => setDialougemodalShow(false)}
            hideallpopups={() => { setDialougemodalShow(false); refereshPage(); }}
            modelheading={modelhdng}
            modelbody={modelbdy}
            modelicon={MdlIcon}
          />
        </Fragment>
      ) : (<div><h5></h5></div>)}
    </div>
  );
};

export default BankAccountHolderDetails;
